import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';
// import { BONUS_TYPE} from './../../constants/subjectTypes'

const SubjectTestSuccess = (props) => {
  // const bonus = BONUS_TYPE[props.subject] || null;
  // const bonusBalance = 35;

  return (
    <div>
      <h3 className={classnames(baseStyles.title_small, baseStyles.text_success, baseStyles.left, baseStyles.mb_15)}>Congratulations!</h3>
        <div>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
            This is the last stage of your application process. It requires completing a short test task to check your problem solving skills. Good luck!
          </p>
        </div>
    </div>
  );
};

export default SubjectTestSuccess;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/SubjectTestSuccess.js